import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { Banner } from "../../../../ui/organisms/banner"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { BusinessRegisterCreation, BusinessRegisterUpdate, BusinessRegisterValidation, GetBusinessRegisterById, resetAddedRegisterCreationRequest, resetBusinessRegisterCreationRequest, resetBusinessRegisterCreationStatus, resetBusinessRegisterErrors, resetBusinessRegisterUpdateStatus, resetBusinessRegisterValidationStatus, resetGetAllAddedRegistersResponse, resetGetBusinessRegisterByIdStatus, setAddedRegisterCreationBusinessRegisterId, setAddedRegisterCreationCustomerId, setAddedRegisterCreationOfficerId, setBusinessRegisterCreationCustomerId, setBusinessRegisterCreationOfficerId, setBusinessRegisterUpdateNote, setBusinessRegisterUpdateReleaseDate, setBusinessRegisterUpdateReleaseProtocolId, setBusinessRegisterUpdateReleaseRegister, setBusinessRegisterUpdateRequestProtocolId, setBusinessRegisterUpdateRequestReason, setBusinessRegisterUpdateRequestType, setFromCreationToUpdate, setGetAllAddedRegistersFiltersBusinessRegisterId } from "../slice"
import { AddRegistroForms } from "./forms"
import { AddRegistroRight } from "./right"

export function AddRegistroAziendale() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const userState = useAppSelector(state => state.users)
    const registerState = useAppSelector(state => state.register)
    const sessionState = useAppSelector(state => state.session)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        dispatch(resetBusinessRegisterErrors())
        dispatch(resetAddedRegisterCreationRequest())
        dispatch(resetGetAllAddedRegistersResponse())
        dispatch(resetBusinessRegisterCreationRequest())
        dispatch(resetBusinessRegisterCreationStatus())
        dispatch(setFromCreationToUpdate(false))
        dispatch(setBusinessRegisterCreationCustomerId(sessionState.selected.customerId))
        dispatch(setBusinessRegisterCreationOfficerId(userState.findMeResponse.id))
    }, [])

    useEffect(() => {
        if (registerState.businessRegisterCreationStatus === 'successfully' ||
            registerState.businessRegisterUpdateStatus === 'successfully'
        ) {
            dispatch(resetBusinessRegisterUpdateStatus())
            setShowSuccess(true)
        }
    }, [registerState.businessRegisterCreationStatus,
    registerState.businessRegisterUpdateStatus
    ])

    useEffect(() => {
        if (registerState.businessRegisterCreationStatus === 'successfully' &&
            registerState.businessRegisterCreationResponse !== undefined
        ) {
            dispatch(resetBusinessRegisterCreationStatus())
            dispatch(GetBusinessRegisterById(registerState.businessRegisterCreationResponse))
        }
    }, [registerState.businessRegisterCreationStatus])

    useEffect(() => {
        if (registerState.getBusinessRegisterByIdStatus === 'successfully' &&
            registerState.getBusinessRegisterByIdResponse !== undefined
        ) {
            dispatch(resetGetBusinessRegisterByIdStatus())
            const data = registerState.getBusinessRegisterByIdResponse
            dispatch(setBusinessRegisterUpdateRequestProtocolId(data.requestProtocolId))
            dispatch(setBusinessRegisterUpdateRequestType(data.requestType))
            dispatch(setBusinessRegisterUpdateRequestReason(data.requestReason))
            dispatch(setBusinessRegisterUpdateReleaseRegister(data.releaseRegister))
            dispatch(setBusinessRegisterUpdateReleaseProtocolId(data.releaseProtocolId))
            dispatch(setBusinessRegisterUpdateReleaseDate(data.releaseDate))
            dispatch(setBusinessRegisterUpdateNote(data.note))
            dispatch(setAddedRegisterCreationOfficerId(userState.findMeResponse.id))
            dispatch(setAddedRegisterCreationCustomerId(sessionState.selected.customerId))
            dispatch(setGetAllAddedRegistersFiltersBusinessRegisterId(data.id))
            dispatch(setAddedRegisterCreationBusinessRegisterId(data.id))
            dispatch(setFromCreationToUpdate(true))
        }
    }, [registerState.getBusinessRegisterByIdStatus])

    useEffect(() => {
        if (registerState.businessRegisterValidationStatus === 'successfully') {
            dispatch(resetBusinessRegisterValidationStatus())
            !registerState.fromCreationToUpdate ?
                dispatch(BusinessRegisterCreation(registerState.businessRegisterCreationRequest)) :
                dispatch(BusinessRegisterUpdate({ body: registerState.businessRegisterUpdateRequest, id: registerState.businessRegisterIdToUpdate }))
        }
    }, [registerState.businessRegisterValidationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CLIENTI}
                breadcrumbItems={['Gestione Clienti', 'Registri Aziendali', 'Nuovo Registro Aziendale']}
                noPaddingLat
                headerLabel="Registri Aziendali"
                headerIcon={
                    <ArrowLeftIcon onClick={() => navigate('/registriAziendali')} color={colors.brandPrimary[50]} size={0} />
                }
                headerChildren={
                    <div className="flex items-center h-full w-full justify-end">
                        <ButtonComponent
                            iconPosition='off'
                            variant='solid'
                            color='orange'
                            size='sm'
                            label='Salva'
                            onClick={() => dispatch(BusinessRegisterValidation(
                                !registerState.fromCreationToUpdate ?
                                    registerState.businessRegisterCreationRequest :
                                    registerState.businessRegisterUpdateRequest
                            ))}
                        />
                    </div>
                }
            >
                <div className="flex flex-col w-full h-full overflow-hidden">
                    {
                        showSuccess &&
                        <div className="px-6 pt-3 pb-1">
                            <div className="rounded-xl border-2 border-green-200 bg-green-50 px-6 py-5 text-left">
                                <span className="block text-sm font-semibold text-green-700">
                                    Dati salvati correttamente.
                                </span>
                            </div>
                        </div>
                    }
                    <div className="flex flex-1 overflow-hidden">
                        <div className="flex-[0.7] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200">
                            <AddRegistroForms />
                        </div>
                        <div className="flex-[0.3] overflow-y-auto bg-white">
                            <RightBar disabled={!registerState.fromCreationToUpdate}>
                                <AddRegistroRight />
                            </RightBar>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione RID']}
            noPaddingLat
            headerLabel={"Registri Aziendali"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}